<template>
	<div>
		<div class="vx-row">
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
				<statistics-card-line icon="UsersIcon" :statistic="analytics.users" statisticTitle="کاربران" type='area' :hideChart='true'></statistics-card-line>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
				<statistics-card-line icon="TruckIcon" :statistic="analytics.ordersProduct" statisticTitle="سفارشات محصول" type='area' :hideChart='true'></statistics-card-line>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">      
				<statistics-card-line icon="ShoppingBagIcon" :statistic="analytics.ordersService" statisticTitle="سفارشات سرویس" type='area' :hideChart='true'></statistics-card-line>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
				<statistics-card-line icon="DollarSignIcon" :statistic="analytics.factors" statisticTitle="فاکتورهای پرداخت نشده" type='area' :hideChart='true'></statistics-card-line>
			</div>
		</div>

		<div class="vx-row">
            <div class="vx-col w-full md:w-1/2 ">
				<vx-card class="vx-card mx-1 my-5">
					<chartjs-component-bar-chart v-if="loaded" :height='150' :data="customersData" :options="customersOptions"></chartjs-component-bar-chart>
				</vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2 ">
				<vx-card class="vx-card mx-1 my-5">
					<chartjs-component-pie-chart v-if="loaded" :height='150' :data="productOrderData" :options="productOrderOptions"></chartjs-component-pie-chart>
				</vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2 ">
				<vx-card class="vx-card mx-1 my-5">
					<chartjs-component-doughnut-chart v-if="loaded" :height='150' :data="serviceOrderData" :options="serviceOrderOptions"></chartjs-component-doughnut-chart>
				</vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2 ">
				<vx-card class="vx-card mx-1 my-5">
					<chartjs-component-horizontal-bar-chart v-if="loaded" :height='150' :data="incomeData" :options="incomeOptions"></chartjs-component-horizontal-bar-chart>
				</vx-card>
            </div>
        </div>
	</div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChartjsComponentBarChart from "./../components/ChartjsComponentBarChart.vue"
import ChartjsComponentHorizontalBarChart from "./../components/ChartjsComponentHorizontalBarChart.vue"
import ChartjsComponentDoughnutChart from "./../components/ChartjsComponentDoughnutChart.vue"
import ChartjsComponentPieChart from "./../components/ChartjsComponentPieChart.vue"

// Chart.defaults.global.defaultFontFamily = 'tahoma';

import axios from 'axios'
import Pushe from "pushe-webpush";
Pushe.init("qd23kk381j05xk4e");
Pushe.subscribe({"showDialog":true,"icon":"","title":"فعالسازی دریافت اعلان","content":"برای دریافت اعلان های AkamApp گزینه تایید را انتخاب نمایید.","position":"top-center","direction":"rtl","acceptText":"تایید","rejectText":"انصراف","promptTheme":"pushe-prompt-theme2","mobilePosition":"top","dialogRetryRate":0});


export default {
	data() {
		return{
			analytics: {},

			loaded: false,
			
			customersData: {},
			productOrderData: {},
			serviceOrderData: {},
			incomeData: {},			
			
			
            customersOptions: {
				legend: {
					display: false
				},
                title: {
                    display: true,
                    text: 'آمار ثبت نام مشتریان'
                }
			},
			productOrderOptions: {
				legend: {
					display: false
				},
                title: {
                    display: true,
                    text: 'سفارشات محصول'
                }
			},
			incomeOptions: {
				legend: {
					display: false
				},
                title: {
                    display: true,
                    text: 'درآمد'
                }
			},
			serviceOrderOptions: {
				legend: {
					display: false
				},
                title: {
                    display: true,
                    text: 'سفارشات آکام سرویس'
                }
			},
			

   
    

		}
	},

	components: {
		StatisticsCardLine,
		ChartjsComponentBarChart,
		ChartjsComponentHorizontalBarChart,
		ChartjsComponentDoughnutChart,
		ChartjsComponentPieChart
	},

	created() {
        this.$vs.loading()
        this.$store.dispatch("analytics").then((res) => {
			this.analytics = res.data[0]
			this.$vs.loading.close()
		}).catch(() => {
			this.$vs.loading.close()
			this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
			})
		})
		this.$store.dispatch("charts").then((res) => {
			this.customersData = res.data.customers
			this.productOrderData = res.data.productOrder
			this.serviceOrderData = res.data.serviceOrder
			this.incomeData = res.data.income
			this.loaded = true
		})
		
		Pushe.getDeviceId()
        .then(function(deviceId) {
          let info = {
            device_id: `${deviceId}`
		  }
            axios({ url: `https://appapi.akambc.com/api/admin/deviceId`, data: info , method: 'POST' })
        });

    },
}
</script>>